export default __webpack_public_path__ + "static/media/confirmation1.2caf51f3.jpg";